import CommonHelmet from '@src/components/CommonHelmet';
import KybMembershipTerms from '@src/features/company/footer/KybMembershipTerms';

function FooterKybMembershipTerms() {
  return (
    <>
      <CommonHelmet />
      <KybMembershipTerms />
    </>
  );
}

export default FooterKybMembershipTerms;
